import { useSliceContext } from "@components/SliceProvider"
import { useState } from "react"
import Spinner from "@components/icons/Spinner"
import { useAccount, erc20ABI, useConnect } from "wagmi"
import { sendTransaction, writeContract, switchNetwork } from "@wagmi/core"
import { formatEther, parseAbi, parseEther } from "viem"
import CoinbaseWalletLogo from "@components/icons/CoinbaseWalletLogo"
// import UniswapLogo from "@components/icons/UniswapLogo"
import baseInstructionsImg from "@src/public/baseInstructions.png"
import baseInstructionsImg1 from "@src/public/baseInstructions1.png"
import Chevron from "@components/icons/Chevron"
import { useAddRecentTransaction } from "@rainbow-me/rainbowkit"
import Check from "@components/icons/Check"
import { useSIWEAccount } from "react-walletkit"
import { Input } from "@components/ui/base/input"
import { Label } from "@src/components/ui/label"
import { Button } from "@components/ui/base/button"
import CopyAddress from "@src/components/ui/CopyAddress"
import PayWithCoinbaseButton from "@src/components/ui/PayWithCoinbaseButton"
import { shortenAddress } from "@src/lib/shortenAddress"
import { constants } from "@src/constants"
import { useAccountBalance } from "@src/lib/getAccountBalance"
import executeTransaction from "@src/lib/executeTransaction"
import { Separator } from "@src/components/ui/separator"

export const TOPUP_VIEW = (params: any) => {
  const {
    ethBalance,
    usdcBalance,
    ethSenderBalance,
    usdcSenderBalance,
    ethSenderBridge,
    totalPriceEth,
    totalPriceUsdc,
    accountTopUpAddress,
    senderWallet
  } = params
  const { appChainId, setModalView } = useSliceContext()
  // const usdc = constants[appChainId].addresses["USDCPriceFeed"]
  const bridgeChainId = appChainId === 8453 ? 1 : 5
  const addRecentTransaction = useAddRecentTransaction()
  const isCheckout = totalPriceEth || totalPriceUsdc
  const { address: signerWallet, connector: signerConnector } = useSIWEAccount()
  const { address: account, connector: activeConnector } = useAccount()
  const { connectAsync } = useConnect()
  const [isCollapsed, setIsCollapsed] = useState(true)

  const isCoinbaseWallet =
    activeConnector?.id == "coinbaseWallet" ||
    signerConnector?.id == "coinbaseWallet"
  const { data: currentBalance, mutate } = useAccountBalance(
    accountTopUpAddress,
    signerWallet || account,
    {
      ethBalance,
      usdcBalance,
      ethSenderBalance,
      usdcSenderBalance,
      ethSenderBridge
    },
    bridgeChainId,
    appChainId
  )
  const formattedTotalPriceEth = totalPriceEth
    ? parseEther(String(totalPriceEth))
    : BigInt(0)
  const missingEth = (currentBalance.ethBalance || 0) < formattedTotalPriceEth
  const missingUsdc = (currentBalance.usdcBalance || 0) < totalPriceUsdc
  const ethTopUpAmount =
    formattedTotalPriceEth - BigInt(currentBalance.ethBalance || 0)
  const usdcTopUpAmount = Number(
    (totalPriceUsdc || 0) - Number(currentBalance.usdcBalance || 0)
  )
  const formattedUsdcTopUpAmount = Math.ceil(usdcTopUpAmount / 10 ** 6)
  const formattedEthTopUpAmount =
    Math.ceil(Number(formatEther(ethTopUpAmount)) * 1000) / 1000
  const getMinUsdcTopUpAmount = () => {
    return Math.min(
      formattedUsdcTopUpAmount,
      currentBalance?.usdcSenderBalance != undefined
        ? Math.floor(Number(currentBalance?.usdcSenderBalance) / 10 ** 6)
        : 0
    )
  }

  const [inputSendUsdcTopUpAmount, setInputSendUsdcTopUpAmount] = useState(
    getMinUsdcTopUpAmount()
  )
  const [isSendUsdcLoading, setIsSendUsdcLoading] = useState(false)
  const [isSendUsdcSuccess, setIsSendUsdcSuccess] = useState(false)
  const getMinEthTopUpAmount = (ethAmount: bigint | undefined) => {
    return Math.min(
      formattedEthTopUpAmount,
      ethAmount != undefined
        ? Math.floor(Number(formatEther(ethAmount)) * 1000) / 1000
        : 0
    )
  }
  const [inputSendEthTopUpAmount, setInputSendEthTopUpAmount] = useState(
    getMinEthTopUpAmount(currentBalance?.ethSenderBalance)
  )
  const [isSendEthLoading, setIsSendEthLoading] = useState(false)
  const [isSendEthSuccess, setIsSendEthSuccess] = useState(false)
  const [inputBridgeEthTopUpAmount, setInputBridgeEthTopUpAmount] = useState(
    getMinEthTopUpAmount(currentBalance?.ethSenderBridge)
  )
  const [isBridgeEthLoading, setIsBridgeEthLoading] = useState(false)
  const [isBridgeEthSuccess, setIsBridgeEthSuccess] = useState(false)

  return (
    <>
      {!isCheckout || missingEth || missingUsdc ? (
        <>
          <div className="sl-pb-3 sl-text-center">
            <h1 className="sl-fonts">Top up wallet</h1>
          </div>
          <div className="sl-pb-4 sl-text-center">
            <div className="sl-pl-4">
              <CopyAddress slicerAddress={accountTopUpAddress} />
            </div>
            {isCheckout && (
              <p className="sl-pt-6 sl-text-muted-foreground sl-mx-auto sl-max-w-[460px]">
                There aren&apos;t enough funds on Base in your wallet to
                checkout. Use these options to top up, or send funds (on Base)
                directly to the address above.
              </p>
            )}
          </div>
          <div className="sl-pt-4 sl-space-y-10">
            <Separator />
            {isCheckout && !missingUsdc ? null : (
              <div className="sl-space-y-6 sl-max-w-[320px] sl-mx-auto">
                <div className="sl-mx-auto sl-mb-5">
                  <h2 className="sl-text-xl">USDC</h2>

                  {isCheckout && (
                    <p className="sl-text-sm sl-text-muted-foreground sl-font-normal sl-mb-0.5">
                      {missingUsdc ? (
                        <>
                          Top up at least{" "}
                          <strong>{formattedUsdcTopUpAmount} USDC</strong>
                        </>
                      ) : (
                        <span className="sl-flex sl-items-center sl-gap-1 sl-text-green-600">
                          No need to top up <Check className="sl-w-4 sl-h-4" />
                        </span>
                      )}
                    </p>
                  )}
                  <p className="sl-text-muted-foreground sl-text-sm sl-self-end">
                    Balance:{" "}
                    {currentBalance.usdcBalance != undefined ? (
                      <>
                        {Math.floor(
                          Number(currentBalance.usdcBalance) / 10 ** 6
                        )}{" "}
                        USDC
                      </>
                    ) : (
                      <Spinner className="sl-inline-block sl-w-4 sl-h-4" />
                    )}
                  </p>
                </div>
                <div className="sl-space-y-7">
                  {senderWallet && (
                    <div className="sl-mx-auto sl-mb-8">
                      {!isSendUsdcSuccess ? (
                        <>
                          <Label className="sl-text-sm sl-font-medium">
                            Send from your wallet{" "}
                            <span className="sl-text-sm sl-font-normal">
                              ({shortenAddress(senderWallet, "...")})
                            </span>
                            <p className="sl-text-[0.8rem] sl-text-muted-foreground sl-font-normal">
                              Up to{" "}
                              {currentBalance?.usdcSenderBalance !=
                              undefined ? (
                                `${Math.floor(
                                  Number(currentBalance?.usdcSenderBalance) /
                                    10 ** 6
                                )} USDC`
                              ) : (
                                <Spinner className="sl-inline-block sl-w-4 sl-h-4 sl-ml-1" />
                              )}
                            </p>
                          </Label>
                          <div className="sl-flex sl-gap-2 sl-mt-2">
                            <Input
                              value={inputSendUsdcTopUpAmount}
                              onChange={(e) =>
                                setInputSendUsdcTopUpAmount(
                                  Number(e.currentTarget.value)
                                )
                              }
                              type="number"
                              min="0"
                              step="1"
                              max={
                                currentBalance?.usdcSenderBalance &&
                                Math.floor(
                                  Number(currentBalance?.usdcSenderBalance) /
                                    10 ** 6
                                )
                              }
                              prefix="$"
                              disabled={
                                currentBalance?.usdcSenderBalance == BigInt(0)
                              }
                            />
                            <Button
                              loading={isSendUsdcLoading}
                              onClick={async () => {
                                setIsSendUsdcLoading(true)
                                const smartWalletConnector = activeConnector
                                await connectAsync({
                                  connector: signerConnector
                                })
                                try {
                                  if (
                                    (await signerConnector.getChainId()) !=
                                    appChainId
                                  ) {
                                    await switchNetwork({
                                      chainId: appChainId
                                    })
                                  }
                                  await executeTransaction(
                                    () =>
                                      writeContract({
                                        address:
                                          constants[appChainId].addresses[
                                            "USDCPriceFeed"
                                          ],
                                        abi: erc20ABI,
                                        functionName: "transfer",
                                        args: [
                                          accountTopUpAddress,
                                          inputSendUsdcTopUpAmount * 10 ** 6
                                        ]
                                      }),
                                    undefined,
                                    `Fund USDC (Send from wallet)`,
                                    addRecentTransaction,
                                    () => {
                                      mutate()
                                      setTimeout(() => {
                                        setIsSendUsdcSuccess(true)
                                      }, 500)
                                    },
                                    undefined
                                  )
                                } catch (err) {
                                  console.log(err)
                                }
                                await connectAsync({
                                  connector: smartWalletConnector
                                })
                                setIsSendUsdcLoading(false)
                              }}
                            >
                              Send
                              {!isSendUsdcLoading && (
                                <span className="sl-inline-block">
                                  <Chevron className="sl-w-5 sl-h-5 sl-rotate-180" />
                                </span>
                              )}
                            </Button>
                          </div>
                        </>
                      ) : (
                        <div className="sl-text-left sl-text-green-600">
                          <div className="sl-flex sl-items-center sl-gap-1">
                            <p className="sl-text-sm sl-font-semibold">
                              USDC sent successfully
                            </p>
                            <Check className="sl-w-4 sl-h-4" />
                          </div>
                          <span
                            className="sl-text-[0.8rem] sl-underline sl-cursor-pointer sl-opacity-70 hover:sl-opacity-100"
                            onClick={() => {
                              setIsSendUsdcSuccess(false)
                              setInputSendUsdcTopUpAmount(
                                getMinUsdcTopUpAmount()
                              )
                            }}
                          >
                            Send more
                          </span>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="sl-text-center">
                    <PayWithCoinbaseButton
                      usdcTopUpAmount={formattedUsdcTopUpAmount}
                      mutate={mutate}
                    />
                  </div>
                  {/* <div className="sl-text-center">
                    <a
                      href={`https://app.uniswap.org/swap?exactField=output&exactAmount=${formattedUsdcTopUpAmount}&chain=base&inputCurrency=ETH&outputCurrency=${usdc}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button className="sl-bg-pink-500 hover:sl-bg-pink-700 sl-group sl-text-white sl-w-[280px]">
                        <span className="sl-flex sl-items-center sl-gap-x-2.5">
                          <span>Swap USDC on Uniswap</span>
                          <span className="sl-w-[22px] sl-h-[22px]">
                            <UniswapLogo className="sl-text-white" />
                          </span>
                        </span>
                      </Button>
                    </a>
                  </div> */}
                  {isCoinbaseWallet && (
                    <>
                      <div
                        className="sl-flex sl-items-center sl-justify-between sl-mx-auto sl-my-2 sl-cursor-pointer sl-group"
                        onClick={() => setIsCollapsed(!isCollapsed)}
                      >
                        <div className="sl-ml-4 sl-flex sl-items-center sl-gap-2">
                          <Chevron
                            className={`sl-w-6 sl-transition-transform sl-duration-200 sl-ease-out ${
                              isCollapsed
                                ? "group-hover:sl-translate-x-[6px] sl-rotate-180"
                                : "sl-rotate-[270deg]"
                            }`}
                          />
                          <p className="sl-font-semibold">
                            Swap on Coinbase Wallet
                          </p>
                          <div className="sl-w-6 sl-mr-3">
                            <CoinbaseWalletLogo />
                          </div>
                        </div>
                      </div>
                      <div
                        className={
                          isCollapsed
                            ? "sl-hidden"
                            : "sl-block sl-prose sl-prose-sm sl-mx-auto sl-text-left"
                        }
                      >
                        <ol className="sl-pl-0">
                          <li>
                            <p>
                              On Coinbase Wallet, click on the{" "}
                              <strong>Assets</strong> tab at the bottom and then
                              on the <strong>Buy</strong> or{" "}
                              <strong>Swap</strong> buttons.
                            </p>
                          </li>
                          <img
                            src={baseInstructionsImg}
                            alt="Swap USDC for ETH"
                            width={300}
                            height={300}
                            className="sl-mx-auto sl-rounded-lg"
                          />
                          <li>
                            <p>
                              To swap, select ETH (or another asset) as input
                              token and <strong>USDC</strong> as the token to{" "}
                              <strong>receive</strong>.
                            </p>
                          </li>
                          <img
                            src={baseInstructionsImg1}
                            alt="Swap USDC for ETH"
                            width={300}
                            height={300}
                            className="sl-mx-auto sl-rounded-lg"
                          />
                          <li>
                            <p>When completed, you can checkout again.</p>
                          </li>
                        </ol>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            {missingEth && missingUsdc && <Separator />}
            {isCheckout && !missingEth ? null : (
              <div className="sl-max-w-[320px] sl-mx-auto">
                <div className="sl-mx-auto sl-mb-5">
                  <h2 className="sl-text-xl">ETH</h2>
                  {isCheckout && (
                    <p className="sl-text-sm sl-text-muted-foreground sl-font-normal sl-mb-0.5">
                      {missingEth ? (
                        <>
                          Top up at least{" "}
                          <strong>{formattedEthTopUpAmount} ETH</strong>
                        </>
                      ) : (
                        <span className="sl-flex sl-items-center sl-gap-1 sl-text-green-600">
                          No need to top up <Check className="sl-w-4 sl-h-4" />
                        </span>
                      )}
                    </p>
                  )}
                  <p className="sl-text-muted-foreground sl-text-sm sl-self-end">
                    Balance:{" "}
                    {currentBalance.ethBalance != undefined ? (
                      <>
                        {Math.floor(
                          Number(formatEther(currentBalance.ethBalance)) * 1000
                        ) / 1000}{" "}
                        ETH
                      </>
                    ) : (
                      <Spinner className="sl-inline-block sl-w-4 sl-h-4" />
                    )}
                  </p>
                </div>
                <div className="sl-space-y-7">
                  {senderWallet && (
                    <div className="sl-mx-auto">
                      {!isSendEthSuccess ? (
                        <>
                          <Label className="sl-text-sm sl-font-medium">
                            Send from your wallet{" "}
                            <span className="sl-text-sm sl-font-normal">
                              ({shortenAddress(senderWallet, "...")})
                            </span>
                            <p className="sl-text-[0.8rem] sl-text-muted-foreground sl-font-normal">
                              Up to{" "}
                              {currentBalance?.ethSenderBalance != undefined ? (
                                `${
                                  Math.floor(
                                    Number(
                                      formatEther(
                                        currentBalance?.ethSenderBalance
                                      )
                                    ) * 1000
                                  ) / 1000
                                } ETH`
                              ) : (
                                <Spinner className="sl-inline-block sl-w-4 sl-h-4 sl-ml-1" />
                              )}
                            </p>
                          </Label>
                          <div className="sl-flex sl-gap-2 sl-mt-2">
                            <Input
                              value={inputSendEthTopUpAmount}
                              onChange={(e) =>
                                setInputSendEthTopUpAmount(
                                  Number(e.currentTarget.value)
                                )
                              }
                              type="number"
                              min="0"
                              step="0.001"
                              max={
                                currentBalance?.ethSenderBalance &&
                                formatEther(currentBalance?.ethSenderBalance)
                              }
                              prefix="Ξ"
                              disabled={
                                currentBalance?.ethSenderBalance == BigInt(0)
                              }
                            />
                            <Button
                              loading={isSendEthLoading}
                              onClick={async () => {
                                setIsSendEthLoading(true)
                                const smartWalletConnector = activeConnector
                                await connectAsync({
                                  connector: signerConnector
                                })
                                try {
                                  if (
                                    (await signerConnector.getChainId()) !=
                                    appChainId
                                  ) {
                                    await switchNetwork({
                                      chainId: appChainId
                                    })
                                  }
                                  await executeTransaction(
                                    () =>
                                      sendTransaction({
                                        to: accountTopUpAddress,
                                        value: parseEther(
                                          String(inputSendEthTopUpAmount)
                                        )
                                      }),
                                    undefined,
                                    `Fund ETH (Send from wallet)`,
                                    addRecentTransaction,
                                    () => {
                                      mutate()
                                      setTimeout(() => {
                                        setIsSendEthSuccess(true)
                                      }, 500)
                                    }
                                  )
                                } catch (err) {
                                  console.log(err)
                                }
                                await connectAsync({
                                  connector: smartWalletConnector
                                })
                                setIsSendEthLoading(false)
                              }}
                            >
                              Send
                              {!isSendEthLoading && (
                                <span className="sl-inline-block">
                                  <Chevron className="sl-w-5 sl-h-5 sl-rotate-180" />
                                </span>
                              )}
                            </Button>
                          </div>
                        </>
                      ) : (
                        <div className="sl-text-left sl-text-green-600">
                          <div className="sl-flex sl-items-center sl-gap-1">
                            <p className="sl-text-sm sl-font-semibold">
                              ETH Sent successfully
                            </p>
                            <Check className="sl-w-4 sl-h-4" />
                          </div>
                          <p
                            className="sl-inline-block sl-text-[0.8rem] sl-underline sl-cursor-pointer sl-opacity-70 hover:sl-opacity-100"
                            onClick={() => {
                              setIsSendEthSuccess(false)
                              setInputSendEthTopUpAmount(
                                getMinEthTopUpAmount(
                                  currentBalance?.ethSenderBalance
                                )
                              )
                            }}
                          >
                            Send more
                          </p>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="sl-mx-auto sl-mb-8">
                    {!isBridgeEthSuccess ? (
                      <>
                        <Label className="sl-text-sm sl-font-medium">
                          Bridge from Ethereum{" "}
                          {appChainId === 8453 ? "Mainnet" : "Goerli"}{" "}
                          {senderWallet && (
                            <span className="sl-text-sm sl-font-normal">
                              ({shortenAddress(senderWallet, "...")})
                            </span>
                          )}
                          <p className="sl-text-[0.8rem] sl-text-muted-foreground sl-font-normal">
                            Up to{" "}
                            {currentBalance?.ethSenderBridge != undefined ? (
                              `${
                                Math.floor(
                                  Number(
                                    formatEther(currentBalance?.ethSenderBridge)
                                  ) * 1000
                                ) / 1000
                              } ETH`
                            ) : (
                              <Spinner className="sl-inline-block sl-w-4 sl-h-4 sl-ml-1" />
                            )}
                          </p>
                        </Label>
                        <div className="sl-flex sl-gap-2 sl-mt-2">
                          <Input
                            value={inputBridgeEthTopUpAmount}
                            onChange={(e) =>
                              setInputBridgeEthTopUpAmount(
                                Number(e.currentTarget.value)
                              )
                            }
                            type="number"
                            min="0"
                            step="0.001"
                            max={
                              currentBalance?.ethSenderBridge &&
                              formatEther(currentBalance?.ethSenderBridge)
                            }
                            prefix="Ξ"
                            disabled={
                              currentBalance?.ethSenderBridge == BigInt(0)
                            }
                          />
                          <Button
                            loading={isBridgeEthLoading}
                            disabled={
                              currentBalance?.ethSenderBridge == BigInt(0)
                            }
                            onClick={async () => {
                              setIsBridgeEthLoading(true)
                              const smartWalletConnector = activeConnector
                              try {
                                if (signerConnector) {
                                  await connectAsync({
                                    connector: signerConnector
                                  })
                                }
                                if (
                                  (await (
                                    signerConnector || activeConnector
                                  ).getChainId()) != bridgeChainId
                                ) {
                                  await switchNetwork({
                                    chainId: bridgeChainId
                                  })
                                }
                                await executeTransaction(
                                  () =>
                                    writeContract({
                                      address:
                                        constants[appChainId].addresses[
                                          "BaseBridge"
                                        ],
                                      abi: parseAbi([
                                        "function depositTransaction(address,uint256,uint64,bool,bytes)"
                                      ]),
                                      functionName: "depositTransaction",
                                      value: parseEther(
                                        String(inputBridgeEthTopUpAmount)
                                      ),
                                      args: [
                                        accountTopUpAddress,
                                        parseEther(
                                          String(inputBridgeEthTopUpAmount)
                                        ),
                                        100000,
                                        false,
                                        ""
                                      ]
                                    }),
                                  undefined,
                                  undefined,
                                  undefined,
                                  () => {
                                    setIsBridgeEthSuccess(true)
                                  }
                                )
                              } catch (error) {
                                console.log(error)
                              }
                              if (
                                (await (
                                  signerConnector || activeConnector
                                ).getChainId()) != appChainId
                              ) {
                                try {
                                  await switchNetwork({ chainId: appChainId })
                                } catch {}
                              }
                              if (signerConnector) {
                                await connectAsync({
                                  connector: smartWalletConnector
                                })
                              }
                              setIsBridgeEthLoading(false)
                            }}
                          >
                            Bridge
                            {!isBridgeEthLoading && (
                              <span className="sl-inline-block">
                                <Chevron className="sl-w-5 sl-h-5 sl-rotate-180" />
                              </span>
                            )}
                          </Button>
                        </div>
                      </>
                    ) : (
                      <div className="sl-text-left sl-text-green-600">
                        <div className="sl-flex sl-items-center sl-gap-1">
                          <p className="sl-text-sm sl-font-semibold">
                            Payment successful
                          </p>
                          <Check className="sl-w-4 sl-h-4" />
                        </div>
                        <p className="sl-text-[0.8rem]">
                          Wait a few minutes for your balance to update
                        </p>
                      </div>
                    )}
                  </div>
                  <div className="sl-text-center">
                    <PayWithCoinbaseButton
                      ethTopUpAmount={formattedEthTopUpAmount}
                      mutate={mutate}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
          <Separator className="sl-mt-10" />
          <div className="sl-flex sl-justify-center sl-pt-12">
            <Button
              variant="outline"
              onClick={() => setModalView({ name: "" })}
            >
              Go back to checkout
            </Button>
          </div>
        </>
      ) : (
        <div className="sl-space-y-8 sl-text-center">
          <div className="sl-text-center">
            <h1 className="sl-fonts">You&apos;re good to go!</h1>
          </div>
          <div>
            <Button onClick={() => setModalView({ name: "" })}>
              Go back to checkout
            </Button>
            <p className="sl-mt-6 sl-text-sm sl-text-muted-foreground">
              Top up anytime from the top-right menu
            </p>
          </div>
        </div>
      )}
    </>
  )
}

export default TOPUP_VIEW
